import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { SITE } from "@/lib/site";

export default function MobileCTA() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-line bg-white shadow-[0_-8px_30px_rgba(5,59,117,0.12)] md:hidden"
      data-testid="mobile-sticky-bar"
    >
      <a
        data-testid="mobile-bar-call"
        href={SITE.phoneHref}
        className="flex items-center justify-center gap-2 py-4 font-display text-sm font-bold text-navy"
      >
        <Phone className="h-4 w-4 text-brand-blue" /> CALL NOW
      </a>
      <Link
        data-testid="mobile-bar-quote"
        to="/contact"
        className="flex items-center justify-center gap-2 bg-gradient-brand py-4 font-display text-sm font-bold text-white"
      >
        <FileText className="h-4 w-4" /> FREE QUOTE
      </Link>
    </div>
  );
}
